import { FooterMSPByStepName } from "@src/Footer/MSP/FooterMSPByStepName";
import { StepName } from "@src/Steps/Steps";
import React, { MouseEvent } from "react";

type FooterLegalMSPProps = {
  stepName: StepName;
};

export function ProtectionDonneesMSP() {
  const openMailTo = (e: MouseEvent) => {
    window.open("mailto:dpo.msp@mutuelle-msp.fr", "mail");
    e.preventDefault();
  };

  return (
    <p>
      <small>
        Le contrat sâge autonomie vous est proposé par la Mutuelle des Services
        Publics, Mutuelle soumise aux dispositions du Livre II du Code de la
        mutualité n° SIREN 782 825 368 substituée auprès de Solimut Mutuelle de
        France, dont le siège social est situé : Maison de la Mutualité – 1 rue
        François Moisson 13002 Marseille. Mutuelle soumise aux dispositions du
        Livre II du Code de la mutualité n° SIREN 383 143 617 et au contrôle de
        l&apos;Autorité de Contrôle Prudentiel et de Résolution (A.C.P.R. : 4
        place de Budapest – CS 92459 – 75 436 Paris Cedex 9). Elle agit en en
        qualité de distributeur de Tutélaire, créateur et assureur du contrat
        sâge autonomie.
        <br />
        <br />
        <span style={{ textDecoration: "underline" }}>
          Données personnelles :
        </span>{" "}
        les informations recueillies dans le présent formulaire, ont pour
        finalité de pouvoir vous rappeler et répondre à vos questions.
        <br />
        Vous disposez des droits d'accès, de rectification, d'opposition, de
        portabilité, d'effacement et de limitation du traitement vous
        concernant.
        Pour les exercer, adressez un courrier simple au responsable de traitement soit par e-mail à l’adresse électronique suivante : {" "}
        {" "}
        <a
          href="mailto:dpo.msp@mutuelle-msp.fr"
          target="_blank"
          rel="noreferrer"
          onClick={openMailTo}
        >
          dpo.msp@mutuelle-msp.fr
        </a>
        , ou par courrier à l’adresse postale suivante : DPO – MSP / Mutuelle des Services Publics CS 10535, 13236 Marseille Cedex 2.
        <br />
        Pour plus d&apos;informations relatives à la gestion de vos données,
        vous pouvez à tout moment consulter notre politique de confidentialité sur le site internet{' '}
        <a href="https://mutuelle-msp.fr" target="_blank" rel="noreferrer">
          mutuelle-msp.fr
        </a>{" "}
        ou la demander par courrier simple au responsable de traitement de la Mutuelle des Services Publics,
        mutuelle soumise aux dispositions du livre II du Code de la mutualité,
        dont le siège social est situé 1 rue François Moisson 13002 Marseille et immatriculée sous le numéro Siren 782 825 368 substituée auprès de Solimut Mutuelle de France,
        mutuelle soumise aux dispositions du Livre II du Code de la mutualité n° SIREN 383 143 617et au contrôle de l'Autorité de Contrôle Prudentiel et de Résolution
        (A.C.P.R. : 4 place de Budapest – CS 92459 – 75 436 Paris Cedex 9)
      </small>
    </p>
  );
}

export function FooterLegalMSP({ stepName }: FooterLegalMSPProps) {
  return (
    <>
      <div className="footer-legal__part">
        <FooterMSPByStepName stepName={stepName} />
      </div>
      <div className="footer-legal__part">
        <div className="footer-legal__logos">
          <img
            className="footer-legal__logo-tutelaire"
            alt="logo tutelaire"
            src="/logo-tutelaire.png"
          />
          <img
            className="footer-legal__logo-mutualite"
            alt="logo mutualité francaise"
            src="/logo-mutualite-francaise.png"
          />
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.tutelaire.fr/mentions-legales-cookies"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Tutélaire
          </a>
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://mutuelle-msp.fr/mentions-legales"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Mutuelle des Services Publics
          </a>
        </div>
      </div>
    </>
  );
}
